// extracted by mini-css-extract-plugin
export default {"user-info-container":"styles_user-info-container__Trh+C","user-name":"styles_user-name__ez2FF"};